<template>
  <div class="spinner">
    <f7-icon fa="circle-o-notch" class="fa-spin"></f7-icon>
  </div>
</template>

<script>
export default {
}
</script>